<template>
  <div class="card card-with-shadow card-rounded-max card-without-border upload-widget-card">
    <div class="card-body text-center" @click="$emit('uploadFile')">
      <div class="mt-5 mb-4 d-none d-md-block">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" height="16mm" width="22mm"><path d="M.787 6.411l10.012 5.222a.437.437 0 0 0 .402 0l10.01-5.222a.434.434 0 0 0 .186-.585.45.45 0 0 0-.186-.187L11.2.417a.441.441 0 0 0-.404 0L.787 5.639a.439.439 0 0 0-.184.588.453.453 0 0 0 .184.184z" fill="#DDDFE1"/><path d="M21.21 9.589l-1.655-.864-7.953 4.148a1.31 1.31 0 0 1-1.202 0L2.444 8.725l-1.657.864a.437.437 0 0 0-.184.583.427.427 0 0 0 .184.187l10.012 5.224a.437.437 0 0 0 .402 0l10.01-5.224a.434.434 0 0 0 .186-.586.444.444 0 0 0-.186-.184z" fill="#EDEFF0"/></svg>
      </div>
      <div>
        <button class="btn btn-primary btn-lg">
          <i class="fas fa-upload"></i>
          {{ t.upload_image }}
        </button>
      </div>
      <div class="mt-2 mb-4 d-none d-md-block">
        {{ t.or_drop_a_file }}
      </div>

    </div>
    <div class="card-footer small text-muted text-center d-none d-md-block">
      {{ t.paste_text_start }}
      <a href="#" class="text-muted select-photo-url-btn" style="text-decoration: underline;" v-on:click.prevent="$emit('uploadUrl')">{{ t.paste_text_url}}</a>
      {{ t.paste_text_end }}

      <span class="d-inline-block border bg-white px-1 rounded ml-2">ctrl</span> + <span class="d-inline-block border bg-white px-1 rounded">v</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    t: Object
  }
}
</script>

<style lang="scss" scoped>
  button {
    min-width: 226px;
  }
</style>
